import { ListItemButton, IconButton, styled } from '@mui/material'
import StrapiLink from '@templates/strapi-cms/content-types/Link'

const HeaderIconBtn = styled(IconButton)`
  svg {
    font-size: 1.7rem;
  }
  &,
  &:focus {
    outline: none !important;
  }
`

export const LeftSideBtn = styled(HeaderIconBtn)`
  margin-right: ${p => p.theme.spacing(1)};
`

export const RightSideBtn = styled(HeaderIconBtn)`
  margin-left: ${p => p.theme.spacing(2)};
  justify-content: flex-end;
`

export const LogoWrapper = styled(StrapiLink)`
  flex-grow: 1;
  justify-content: center;
  display: flex;
  align-items: center;
  svg {
    max-width: 250px;
    width: 100%;
  }
`
export const LogoWrapperCheckout = styled(StrapiLink)`
  flex-grow: 1;
  justify-content: left;
  display: flex;
  width: 50%;
  height: 20px;
  svg {
    max-width: 250px;
  }
`

export const ListItemText = styled(StrapiLink)`
  padding-top: 4px;
  padding-bottom: 4px;
  display: flex;
  color: ${p => p.theme.palette.primary.dark};
  min-width: 50%;
  text-transform: normal;
  font-size: 16px;
  font-weight: 500;

  &:focus {
    text-decoration: underline;
    color: ${p => p.theme.palette.primary.main};
  }
`

export const FooterLink = styled(StrapiLink)`
  display: flex;
  width: 100%;

  .material-icons-outlined {
    font-size: 2.2rem;
    color: ${p => p.theme.palette.text.primary};
  }

  span.text {
    display: block;
    color: ${p => p.theme.palette.text.primary};
    padding-left: 8px;

    span {
      display: block;
      font-weight: 400;

      &.title {
        font-weight: 600;
      }
    }
  }

  &:focus {
    span,
    .material-icons-outlined {
      color: ${p => p.theme.palette.primary.main};
    }
  }
`
